interface ConcurrencyLock {
  lastUpdated?: string;
  platform?: string;
  platformClass?: string;
  platformAppVersion?: string;
  playContentId?: string;
}
interface Details {
  lock_1_lastupdated?: string;
  lock_2_lastupdated?: string;
  lock_1_platform?: string;
  lock_2_platform?: string;
  lock_1_platform_app_version?: string;
  lock_2_platform_app_version?: string;
  lock_1_playcontentid?: string;
  lock_2_playcontentid?: string;
}
export function mapAdditionalDetailsIntoLockObjects(details: Details) {
  if (details == null) {
    return null;
  }
  const result: ConcurrencyLock[] = [];
  Object.entries(details)
    .filter(x => x[0].startsWith('lock_'))
    .forEach(item => {
      const key = item[0];
      const value = item[1];
      const num = parseInt(key.split('_')[1], 10);

      if (result[num - 1] == null) {
        result[num - 1] = {};
      }
      const lock = result[num - 1];

      const prefixLength = `lock_${num.toString()}_`.length;
      const keyName = key.substring(prefixLength);

      switch (keyName) {
        case 'lastupdated':
          lock.lastUpdated = value;
          break;
        case 'platform':
          lock.platform = value;
          break;
        case 'platform_class':
          lock.platformClass = value;
          break;
        case 'platform_app_version':
          lock.platformAppVersion = value;
          break;
        case 'playcontentid':
          lock.playContentId = value;
          break;
      }
    });
  return result;
}
